'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style"];
import * as React from 'react';
import { useRenderElement } from '@mui/x-scheduler-internals/base-ui-copy';
import { useTimelineGridRowKeyboard } from "../../internals/utils/useTimelineGridRowKeyboard.mjs";
export const TimelineGridTitleRow = /*#__PURE__*/React.forwardRef(function TimelineGridTitleRow(componentProps, forwardedRef) {
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const {
    rowRef,
    handleKeyDown,
    handleFocus
  } = useTimelineGridRowKeyboard({
    columnType: 'title'
  });
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef, rowRef],
    props: [elementProps, {
      tabIndex: 0,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus
    }]
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridTitleRow.displayName = "TimelineGridTitleRow";